import ExternalLinkButton from './ExternalLinkButton';

interface ProfileLinksProps {
    steamId64: string;
}

function ProfileLinks({steamId64}: ProfileLinksProps) {
    return (
        <div className="flex items-center gap-1 flex-shrink-0">
            <ExternalLinkButton
                href={`https://www.faceit.com/en/search/player/${steamId64}`}
                title="Faceit"
                iconUrl="https://www.faceit.com/favicon.ico"
                alt="Faceit"
            />
            <ExternalLinkButton
                href={`https://csstats.gg/player/${steamId64}`}
                title="CSStats.gg"
                iconUrl="https://csstats.gg/favicon.ico"
                alt="CSStats.gg"
            />
            <ExternalLinkButton
                href={`https://leetify.com/app/profile/${steamId64}`}
                title="Leetify"
                iconUrl="https://leetify.com/favicon.ico"
                alt="Leetify"
            />
            <ExternalLinkButton
                href={`https://cstracker.gg/players/${steamId64}`}
                title="CSTracker.gg"
                iconUrl="https://cstracker.gg/favicon.ico"
                alt="CSTracker.gg"
            />
        </div>
    );
}

export default ProfileLinks;
